/**
 * Real-time Event Types
 * Must match backend event naming convention
 */

export enum RealtimeEventType {
  // Notification Events
  NOTIFICATION_NEW = 'notification:new',
  NOTIFICATION_READ = 'notification:read',
  NOTIFICATION_DELETED = 'notification:deleted',
  NOTIFICATION_COUNT_UPDATED = 'notification:count-updated',

  // Comment Events (future)
  COMMENT_NEW = 'comment:new',
  COMMENT_UPDATED = 'comment:updated',
  COMMENT_DELETED = 'comment:deleted',
  COMMENT_LIKED = 'comment:liked',

  // Trip Activity Events (future)
  ACTIVITY_ADDED = 'activity:added',
  ACTIVITY_UPDATED = 'activity:updated',
  ACTIVITY_DELETED = 'activity:deleted',

  // Trip Collaboration Events (future)
  TRIP_SHARED = 'trip:shared',
  TRIP_MEMBER_JOINED = 'trip:member-joined',
  TRIP_MEMBER_LEFT = 'trip:member-left',

  // Chat/Messaging Events (future)
  MESSAGE_NEW = 'message:new',
  MESSAGE_READ = 'message:read',
  USER_TYPING = 'user:typing'
}

/**
 * Event payload interfaces
 */

export interface NotificationNewEvent {
  notificationId: string;
  type: string;
  title: string;
  message: string;
  actorUsername: string;
  actorId?: string;
  tripId?: string;
  destinationId?: string;
  createdAt: Date;
}

export interface NotificationReadEvent {
  notificationId: string;
}

export interface NotificationDeletedEvent {
  notificationId: string;
}

export interface NotificationCountUpdatedEvent {
  count: number;
}

export interface CommentNewEvent {
  commentId: string;
  tripId: string;
  entityType?: string;
  entityId?: string;
  authorId: string;
  authorUsername: string;
  authorPhoto?: string;
  content: string;
  createdAt: Date;
}

export interface CommentUpdatedEvent {
  commentId: string;
  tripId: string;
  entityType?: string;
  entityId?: string;
  content: string;
  updatedAt: Date;
}

export interface CommentDeletedEvent {
  commentId: string;
  tripId: string;
  entityType?: string;
  entityId?: string;
}

export interface ActivityAddedEvent {
  activityId: string;
  tripId: string;
  destinationId: string;
  name: string;
  addedBy: string;
}

// Union type for all possible event payloads
export type RealtimeEventPayload =
  | NotificationNewEvent
  | NotificationReadEvent
  | NotificationDeletedEvent
  | NotificationCountUpdatedEvent
  | CommentNewEvent
  | CommentUpdatedEvent
  | CommentDeletedEvent
  | ActivityAddedEvent;
